export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyDcN5xGRBi-7g1fYBuobZrWuj6rrH9jKhc",
    authDomain: "abc-angular-db25d.firebaseapp.com",
    databaseURL: "https://abc-angular-db25d.firebaseio.com",
    projectId: "abc-angular-db25d",
    storageBucket: "abc-angular-db25d.appspot.com",
    messagingSenderId: "558525753742"
  }
};



// WEBPACK FOOTER //
// /Users/elliot/code/abc-angular/src/environments/environment.ts